import { render } from "./StatusReason.vue?vue&type=template&id=17c95ac8"
import script from "./StatusReason.vue?vue&type=script&lang=js"
export * from "./StatusReason.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/felipe_admin_sr/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__